import { FC } from "react";
import { CooldownButton, CooldownButtonProps } from "./CooldownButton"

export type ItemButtonProps = {

} & Omit<CooldownButtonProps, 'width' | 'height'>;

export const ItemButton: FC<ItemButtonProps> = ({ ...rest }) => {
    return (<CooldownButton showLevels width={88} height={64} fontSize={32} effectedByOctarine {...rest} />);
}